import { ImageProps } from '../types';

export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  className = '',
  loading = 'lazy',
  srcset,
  sizes,
  style,
}) => {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      srcSet={srcset}
      sizes={sizes}
      className={className}
      decoding="async"
      style={style}
    />
  );
};
